export default class Paytypes {
  constructor() {
    this.catElements = document.querySelectorAll('.payment-method')
    this.init = this.init.bind(this)
    this.update = this.update.bind(this)

    this.init()
  }

  init() {
    this.categories = []
    //for (var cat of this.catElements) {
    Array.prototype.slice.call(this.catElements).forEach(cat => {
      const t = new PaytypeCategory(this, cat)
      this.categories.push(t)
    })

    this.update()
  }

  update() {
      Array.prototype.slice.call(this.categories).forEach(cat => {
      // for (var cat of this.categories)
      cat.update()
    })
  }
}

class PaytypeCategory {
  constructor(categories, el) {
    this.categories = categories;
    this.el = el
    this.methods = el.querySelectorAll('.paytype');
    this.description = el.querySelector('.cat-desc')
    this.init = this.init.bind(this)
    this.dirty = this.dirty.bind(this)
    this.update = this.update.bind(this)

    this.init()
  }

  init() {
    this.paytypes = []
    // for (var m of this.methods) {
    Array.prototype.slice.call(this.methods).forEach(m => {
      const t = new Paytype(this, m)
      this.paytypes.push(t);
    })

    if (this.description)
      this.description.classList.add('collapse');
  }

  dirty() {
    this.categories.update()
  }

  update() {
    let checked = false;
    // for (var pt of this.paytypes) {
    Array.prototype.slice.call(this.paytypes).forEach(pt => {
      pt.update()
      checked = checked || pt.isChecked()
    })

    if (this.description) {
      if (checked)
        this.description.classList.add('show')
      else
        this.description.classList.remove('show')
    }
  }
}

class Paytype {
  constructor(category, el) {
    this.category = category
    this.el = el
    this.init = this.init.bind(this)
    this.dirty = this.dirty.bind(this)
    this.update = this.update.bind(this)
    this.isChecked = this.isChecked.bind(this)

    this.init()
  }

  isChecked() {
    return this.radio.checked;
  }

  init() {
    this.radio = this.el.querySelector('input[type=radio]')
    this.description = this.el.querySelector('.desc')
    console.log({ el: this.el, desc: this.description })

    this.radio.addEventListener('change', ev => { this.dirty() })

    if (this.description)
      this.description.classList.add('collapse');
  }

  dirty() {
    this.category.dirty();
  }

  update() {
    if (this.description) {
      if (this.radio.checked)
        this.description.classList.add('show')
      else
        this.description.classList.remove('show')
    }
  }
}